module.exports = __webpack_public_path__ + "static/media/IMG-ab84bfe42c81a0726d7265423780616a-V.9554d243.jpg";